module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "#",
      "method": "post",
      "id": "contact-form",
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Full Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.FullName),
      expression: "contact.FullName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Full Name"
    },
    domProps: {
      "value": (_vm.contact.FullName)
    },
    on: {
      "keydown": function($event) {
        _vm.isTyping = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "FullName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.Email),
      expression: "contact.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.contact.Email)
    },
    on: {
      "keydown": function($event) {
        _vm.isTyping = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "Email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.Message),
      expression: "contact.Message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "rows": "5",
      "id": "message",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.contact.Message)
    },
    on: {
      "keydown": function($event) {
        _vm.isTyping = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "Message", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "col-sm-3 control-label"
  }), _vm._v(" "), _c('va-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "col-sm-9",
    attrs: {
      "type": "danger",
      "dismissible": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.error) + "\n                  ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control pull-right",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "name": "send",
      "type": "button",
      "id": "send",
      "value": "Send"
    },
    on: {
      "click": function($event) {
        return _vm.sendEmail()
      }
    }
  })])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 wow fadeInLeft",
    attrs: {
      "data-wow-delay": "0.6s"
    }
  }, [_c('h2', [_c('strong', [_vm._v("Printer Counters")])]), _vm._v(" "), _c('p', [_vm._v("Printer Counters - ePaper LTD")]), _vm._v(" "), _c('p', [_vm._v("Katom st. 8, Industrial Park Misgav, Israel")]), _vm._v(" "), _c('p', [_vm._v("+972-73-215-29-29")]), _vm._v(" "), _c('p', [_vm._v("support@epapersign.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "control-label",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("Contact Us")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37b86e7b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/contact.vue
// module id = 692
// module chunks = 0